import { render, staticRenderFns } from "./ywcOrder.vue?vue&type=template&id=679f9386&scoped=true"
import script from "./ywcOrder.vue?vue&type=script&lang=js"
export * from "./ywcOrder.vue?vue&type=script&lang=js"
import style0 from "./ywcOrder.vue?vue&type=style&index=0&id=679f9386&prod&lang=css"
import style1 from "./ywcOrder.vue?vue&type=style&index=1&id=679f9386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f9386",
  null
  
)

export default component.exports